import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthModule } from '@auth0/auth0-angular';
import { NG_ENTITY_SERVICE_CONFIG } from '@datorama/akita-ng-entity-service';
import { BreadcrumbsModule } from '@molecules/breadcrumbs/breadcrumbs.module';
import { ContentSectionModule } from '@molecules/content-section/content-section.module';
import { ListModule } from '@molecules/list/list.module';
import { PolicyBreakdownModule } from '@molecules/policy-breakdown/policy-breakdown.module';
import { ProgressBarModule } from '@molecules/progress-bar/progress-bar.module';
import { SidebarInfocardModule } from '@molecules/sidebar-infocard/sidebar-infocard.module';
import { PetInformationComponent } from '@pages/pet-information/pet-information.component';
import { ComboboxModule } from '@shared/combobox/combobox.module';
import { ModalDialogComponent } from '@shared/modal-dialog/modal-dialog.component';
import { SharedModule } from '@shared/shared.module';
import { ToggleOptionModule } from '@shared/toggle-option/toggle-option.module';

import { EnvironmentBannerComponent } from '@ui-core/environment-banner/environment-banner.component';
import { UiCoreModule } from '@ui-core/ui-core.module';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';

import { environment } from '../environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ErrorHandlerService } from './error-handler.service';
import { HomeComponent } from './pages/home/home.component';
import { RetrieveComponent } from './pages/retrieve/retrieve.component';

@NgModule({ declarations: [
	AppComponent,
	PetInformationComponent,
	HomeComponent,
	RetrieveComponent,
],
bootstrap: [AppComponent],
schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [BrowserModule,
	BrowserAnimationsModule,
	AppRoutingModule,
	UiCoreModule,
	EnvironmentBannerComponent,
	BreadcrumbsModule,
	ProgressBarModule,
	ContentSectionModule,
	SidebarInfocardModule,
	PolicyBreakdownModule,
	FormsModule,
	ListModule,
	SharedModule,
	ComboboxModule,
	ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
	ModalDialogComponent,
	RecaptchaV3Module,
	ToggleOptionModule,
	AuthModule.forRoot({
		domain: environment?.USAAAuth?.domain,
		clientId: environment?.USAAAuth?.clientID,
		useRefreshTokens: true,
		authorizationParams: {
			redirect_uri: environment?.USAAAuth?.callbackURL,
		}
	})], providers: [
	{
		provide: APP_INITIALIZER,
		useFactory: () => () => { },
		multi: true
	},
	{
		provide: NG_ENTITY_SERVICE_CONFIG,
		useValue: { baseUrl: 'https://jsonplaceholder.typicode.com' }
	},
	{ provide: ErrorHandler, useClass: ErrorHandlerService },
	{
		provide: RECAPTCHA_V3_SITE_KEY,
		useValue: environment.recaptcha.siteKey,
	},
	provideHttpClient(withInterceptorsFromDi()),
] })
export class AppModule {}
